import React from "react";
import { useLocation } from "react-router-dom";
import {
  Container,
  Card,
  CardContent,
  Typography,
  Box,
  Alert,
  Stack,
} from "@mui/material";

const Success = () => {
  const location = useLocation();
  const { confidence, isLive, capturedImage, ageRange } =
    location.state || {};

  return (
    <Box sx={{ bgcolor: '#f5f5f7', minHeight: '100vh', py: 6 }}>
      <Container
        maxWidth="sm"
        justifyContent="center"
        display="flex"
        alignItems="center"
      >
      <Card elevation={3}>
        <CardContent>
          <Stack spacing={3} alignItems="center">
            <Typography variant="h4" fontWeight="bold">
              Verification Result
            </Typography>

            {capturedImage && (
              <Box
                component="img"
                src={capturedImage}
                alt="Captured Image"
                sx={{
                  width: "100%",
                  maxWidth: 300,
                  height: "auto",
                  borderRadius: 1,
                  boxShadow: 2,
                }}
              />
            )}

            {isLive ? (
              <>
                <Alert severity="success">Liveness Check Passed</Alert>

                <Box textAlign="center">
                  <Typography variant="body1" fontWeight="medium">
                    Liveness Confidence:
                  </Typography>
                  <Typography variant="h6" color="primary">
                    {confidence ? `${confidence}%` : "N/A"}
                  </Typography>
                </Box>

                <Box textAlign="center">
                  <Typography variant="body1" fontWeight="medium">
                    Age Range:
                  </Typography>
                  <Typography variant="h6" color="primary">
                    {ageRange ? `${ageRange.Low} - ${ageRange.High}` : "N/A"}
                  </Typography>
                </Box>
              </>
            ) : (
              <>
                <Alert severity="error">Liveness Check Failed</Alert>
                <Typography variant="body1" color="error">
                  Your confidence level is not sufficient. Please try again.
                </Typography>
              </>
            )}
{/* 
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(`/?token${token}`)}
            >
              Back to Home
            </Button> */}
          </Stack>
        </CardContent>
      </Card>
    </Container>
    </Box>
  );
};

export default Success;
